
import { NgModule, LOCALE_ID, ErrorHandler, Injectable } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AppCustomPreloader } from '@core/services/custom-preloader';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { JWTInterceptor } from '@core/services/jwt-interceptor';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Router, RouterModule } from '@angular/router';
import { AuthGuard } from '@core/guards/auth-guard';
import { PermGuard } from '@core/guards/permissions.guard';
import { MaterialModule } from '@core/modules/genius-material.module';
import { ComingSoonGuard } from '@core/guards/coming-soon.guard';
import { SentryErrorHandler } from '@core/error/Sentry-error-handler.service';
import { RedirectGuard } from '@core/guards/redirect.guard';

import { HammerGestureConfig, HammerModule, HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';
import * as Hammer from 'hammerjs';
import { CommonModule } from '@angular/common';


@Injectable()
export class MyHammerConfig extends HammerGestureConfig {
  overrides = {
    swipe: { direction: Hammer.DIRECTION_ALL },
    pinch: {
      direction: Hammer.DIRECTION_ALL,
      enable: true,
      recognizeWidth: 'rotate'
    },
  };
}

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    CommonModule,
    AppRoutingModule,
    HttpClientModule,
    RouterModule,
    MaterialModule,
    BrowserAnimationsModule,
    HammerModule
  ],
  providers: [
    AppCustomPreloader,
    { provide: HTTP_INTERCEPTORS, useClass: JWTInterceptor, multi: true },
    { provide: LOCALE_ID, useValue: 'en-GB' },
    { provide: ErrorHandler, useClass: SentryErrorHandler },
    AuthGuard,
    PermGuard,
    RedirectGuard,
    ComingSoonGuard,
    { provide: HAMMER_GESTURE_CONFIG, useClass: MyHammerConfig }
  ],
  bootstrap: [AppComponent],
  exports: [
    HammerModule
  ]
})
export class AppModule { }
